/** Bake-time deploy flavor. Unset / anything other than `global` is local — never infer from a missing org pin. */
export function isGlobalSurface(): boolean {
  return import.meta.env.VITE_SURFACE_MODE === 'global';
}

/** Fail-closed for global images: directory URL is required at boot. Local (default) is a no-op. */
export function assertSurfaceModeConfig(): void {
  if (!isGlobalSurface()) return;
  if (!import.meta.env.VITE_CELL_DIRECTORY_URL) {
    throw new Error('VITE_CELL_DIRECTORY_URL is required when VITE_SURFACE_MODE=global');
  }
}
